

const ConnectWallet = () => {

    return(
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20 pb-20 lg:pb-36">
            
            <div className="flex flex-col tracking-wider py-10 max-w-[800px] mx-auto">

                <div className="shadow-shadow3 bg_gradient py-6 px-3 md:px-10 lg:px-20 rounded-[8px] text-gray-400">
                    <h2 className="mb-12 sm:mb-20 text-center text-xl lg:text-2xl xl:text-3xl text-white">Connect Wallet</h2>
                    <div className="flex justify-between items-center p-3 md:p-5 rounded-[8px] mb-5 bg-[#00000073]">
                        <p className='text-center font-medium text-base sm:text-lg'>
                            Coinbase
                        </p>
                        <img src= {require('../../assets/images/wallets/coinbase.png')} alt = 'coinbase' className='h-[14px]'/>
                    </div>

                    <div className="flex justify-between items-center p-3 md:p-5 rounded-[8px] mb-5 bg-[#00000073]">
                        <p className='text-center font-medium text-base sm:text-lg'>
                            Metamask
                        </p>
                        <img src= {require('../../assets/images/wallets/Metamask-icon.png')} alt = 'coinbase' className='h-[15px]'/>
                    </div>

                    <div className="flex justify-between items-center p-3 md:p-5 rounded-[8px] mb-5 bg-[#00000073]">
                        <p className='text-center font-medium text-base sm:text-lg'>
                            TrustWallet
                        </p>
                        <img src= {require('../../assets/images/wallets/twt.png')} alt = 'coinbase' className='h-[14px]'/>
                    </div>

                    <div className="flex justify-between items-center p-3 md:p-5 rounded-[8px] mb-5 bg-[#00000073]">
                        <p className='text-center font-medium text-base sm:text-lg'>
                            Manual Request
                        </p>
                        <svg xmlns="http://www.w3.org/2000/svg" height = '14px' width = '14px' fill = 'currentColor' viewBox="0 0 512 512">
                            <path d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"/>
                        </svg>
                    </div>  
                  
                </div>

            </div>
        
        </div>
    )
}

export default ConnectWallet;